<template>
  <WdsLabel v-if="column.recruiterOwnershipIsExpired" error sm subtle>{{ $t('Expired') }}</WdsLabel>
  <WdsTooltip
    v-else
    :text="
      column.recruiterOwnershipDaysLeft === null
        ? $t('Never expires')
        : $t('Expires in :count days', { count: column.recruiterOwnershipDaysLeft })
    "
    :global="tableGlobals"
  >
    <WdsLabel success sm subtle>{{ $t('Active') }}</WdsLabel>
  </WdsTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const RecruiterPlacementOwnershipColumn = graphql(`
  fragment RecruiterPlacementOwnershipColumn on Hire {
    recruiterOwnershipIsExpired
    recruiterOwnershipDaysLeft
  }
`)

const props = defineProps<{ row: FragmentType<typeof RecruiterPlacementOwnershipColumn> }>()
const column = computed(() => useFragment(RecruiterPlacementOwnershipColumn, props.row))
</script>
